module.exports = __webpack_public_path__ + "images/saaremaa/routes/pointers/RIN-MUN-RIN.png";